const USER_ROLES = {
  user: 'User',
  admin: 'Admin',
  super_admin: 'SuperAdmin'
} as const;

const USER_STATUSES = {
  active: 'Active',
  invited: 'Invited'
} as const;

const USER_TYPES = {
  user: 'User',
  api_user: 'ApiUser'
} as const;

export { USER_ROLES, USER_STATUSES, USER_TYPES };
